<template>
  <div class="v_box1">
    <div class="b_banxin">
      <div class="v_box1list flex">
        <div class="v_box1left">分类：</div>
        <div :class="{v_box1right:true, flex:true, flex_warp:true,v_hei:isFIVE}" ref="getheight">
          <div
            class="v_box1rightson"
            :class="{v_active:active == 'all'}"
            @click="postshopobj('','all')"
          >全部</div>
          <div
            class="v_box1rightson"
            :class="{v_active:active==index}"
            @click="postshopobj(item.id,index)"
            v-for="(item,index) in arrylist"
            :key="index"
          >{{item.name}}</div>
          <img :src="tabciopush" alt :class="{tabcook:true,ishow:isimg}" @click="seeall" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    arrylist: {
//				type: Array,
				default() {
					return [];
				}
			},
    indexs: Boolean
  },
  data() {
    return {
      active: "all",
      isFIVE: false,
      isimg: false,
      tabciopush:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDgwOTVFRTE1MTU1MTFFQUJBMUVCNDUwNEE4RUQ3REUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDgwOTVFRTI1MTU1MTFFQUJBMUVCNDUwNEE4RUQ3REUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODA5NUVERjUxNTUxMUVBQkExRUI0NTA0QThFRDdERSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowODA5NUVFMDUxNTUxMUVBQkExRUI0NTA0QThFRDdERSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlXFmWUAAAH6SURBVHjanJXNS1RRGMavUy6GEAtJSv8KU6xW2iaCwj4WZoMQKc1AkbgRDVqkUJbRrqQhbCGk4sYk+0BqGnFnlLh048qPjYiBIIqlvxeeI8fLzKXxhR8Xzjn3ue95z3PeW5RMJoMcEYebcA3OQIXGl+E3jMEobKbT6QMvxnKINcMCvIIt6IUG8VRjr7UmEX65yMvwCLyBFngBz2A9yB3HoRM6YADukelfmzjqLTKxRrgI34PosA89hEn4oJ3e9bds27wD1/9DzI8fcNXeTaVSCScY1xb7IBMUGGw1y+M5vEQ0HtNpHtPgYaNXGk0xWeMT/NHkJfgJ5RECdoDvXBJkucHjI9wwwWr45i2egxOq5ck8YoOWDXzxxk2jxgQrYdGbWIF61TYj8X2byZ92eFcg680twamYFv0LZbHoiX6FUq3rh9sSCx/gjvOhXafTObbmRLPy20yEWKDruWYZzkJdnuI70TJojRALtO6XCY7rpOMRouegKp+Y+U8GHzfBYdWwPcImqzAfMd8GxfDeBM1DXfAYzhbqaLKr4dENj/DjurvLA+pvE3C+AL1aeXFCLe1AP7Sif4YpeKIWlS9KoAemVdcE2e2G29e2bDGlK3VfVzIj0wa6BBfgMlj/ewBvnVhY0IXd0RG4pdPvlpD7BcyquQ5Z/cO/gD0BBgCdeYA4wtt9XwAAAABJRU5ErkJggg=="
    };
  },
  created() {
    let that = this;
    // if (that.indexs !== ''){
    //   that.active = that.indexs
    // }
    // console.log(that.indexs)
  },
  methods: {
    postshopobj(id, nameid) {
      this.active = nameid;
      this.$emit("postactive", { id: id, index: nameid });
    },
    seeall() {
      if (this.isFIVE) {
        this.tabciopush =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDgwOTVFREQ1MTU1MTFFQUJBMUVCNDUwNEE4RUQ3REUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDgwOTVFREU1MTU1MTFFQUJBMUVCNDUwNEE4RUQ3REUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODA5NUVEQjUxNTUxMUVBQkExRUI0NTA0QThFRDdERSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowODA5NUVEQzUxNTUxMUVBQkExRUI0NTA0QThFRDdERSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pop3QOcAAAHwSURBVHjanJXNS1RRGMbvDNJqwAg3luDSZUS0FD8Jc8SxjVCCQuKMWLoRkwqyReCICNZuFjJEYdrCEnKjC3VVida/UIEahWgfNlDE9HvhuXAb773NeOB3L3PPOc953nPe804kmUw6Pi0GV6EdzsFpfd+Gd/ACnsLPTCbzz8RogVAEbIX3MAEHcBcuiTH4BlPwAa4VOol4HJ6Ax9AhsUn47vi3kzAizGkfTn95HZqzWWiEWrkKEnPk/A7UQSvMFIZ8HdoU1oZTfHuleZ2pVKrXFTT797U/m06JjVDf8LoHaURjJtgFv+FhyLwaqAjpn5a5K/ZIwCLkAgY3KlVeQ1WAy5xSKWGC52EtROylNn1P46oCxq5bzprgKdgJEXsEQ3DxP6K7dgHcUy4LERuAPHyFFm2Nn6hp5e3xCc54Ouol9hxuSMxt+1rMFa309NkC21GlSrOnw3JxDrrhj09oX6BJ4mc9301jy0JdgAcqCD9gtIj0+wwX3B/kXzmvuO11VG4O4ZZz/DYqjfmo9mNYH+tLVcKd7elNKxSWj+4pW2HIKsEbStBr0uFlEXtSWA/7Ff4KjOuOOyHlKw3L8Exzj+SfnWhKGW8FdBCWYBU+aky1tiWu8tbjOnMCEtoN38LohMtw2/MXYDfqrfJz3u/+/xVgAGFWgTwUEV6nAAAAAElFTkSuQmCC";
      } else {
        this.tabciopush =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDgwOTVFRTE1MTU1MTFFQUJBMUVCNDUwNEE4RUQ3REUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDgwOTVFRTI1MTU1MTFFQUJBMUVCNDUwNEE4RUQ3REUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODA5NUVERjUxNTUxMUVBQkExRUI0NTA0QThFRDdERSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowODA5NUVFMDUxNTUxMUVBQkExRUI0NTA0QThFRDdERSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlXFmWUAAAH6SURBVHjanJXNS1RRGMavUy6GEAtJSv8KU6xW2iaCwj4WZoMQKc1AkbgRDVqkUJbRrqQhbCGk4sYk+0BqGnFnlLh048qPjYiBIIqlvxeeI8fLzKXxhR8Xzjn3ue95z3PeW5RMJoMcEYebcA3OQIXGl+E3jMEobKbT6QMvxnKINcMCvIIt6IUG8VRjr7UmEX65yMvwCLyBFngBz2A9yB3HoRM6YADukelfmzjqLTKxRrgI34PosA89hEn4oJ3e9bds27wD1/9DzI8fcNXeTaVSCScY1xb7IBMUGGw1y+M5vEQ0HtNpHtPgYaNXGk0xWeMT/NHkJfgJ5RECdoDvXBJkucHjI9wwwWr45i2egxOq5ck8YoOWDXzxxk2jxgQrYdGbWIF61TYj8X2byZ92eFcg680twamYFv0LZbHoiX6FUq3rh9sSCx/gjvOhXafTObbmRLPy20yEWKDruWYZzkJdnuI70TJojRALtO6XCY7rpOMRouegKp+Y+U8GHzfBYdWwPcImqzAfMd8GxfDeBM1DXfAYzhbqaLKr4dENj/DjurvLA+pvE3C+AL1aeXFCLe1AP7Sif4YpeKIWlS9KoAemVdcE2e2G29e2bDGlK3VfVzIj0wa6BBfgMlj/ewBvnVhY0IXd0RG4pdPvlpD7BcyquQ5Z/cO/gD0BBgCdeYA4wtt9XwAAAABJRU5ErkJggg==";
      }
      this.isFIVE = !this.isFIVE;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 页面渲染完成后的回调
      console.log(this.$refs.getheight.offsetHeight);
      let _thiseight = this.$refs.getheight.offsetHeight;
      if (_thiseight > 51) {
        this.isFIVE = true;
        this.isimg = true;
      }
    });
  }
};
</script>
<style scoped>
.v_box1 {
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  border-bottom: 1px solid #dddddd;
}

.v_box1list {
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
}

.v_box1left {
  height: 50px;
  line-height: 50px;
  width: 60px;
  font-size: 16px;
}
.v_box1right {
  width: calc(100% - 50px);
  box-sizing: border-box;
  height: 50px;
  overflow: hidden;
}

.v_hei {
  height: 50px;
}
.tabcook {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 10px;
  right: 0px;
  object-fit: scale-down;
  display: none;
}
.v_box1rightson {
  margin-left: 20px;
  font-size: 15px;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}

.v_active {
  color: #dc1e33;
}
.ishow {
  display: block;
}
</style>
